'use client';

import dynamic from 'next/dynamic';

// Non-critical overlay widgets (region prompt, cookie banner, credit-limit
// banner) deferred until after hydration. The dynamic() boundaries live in
// this client module — in a server component (the layouts) next/dynamic does
// not client-code-split and its flight-preload path can race chunk
// registration in dev ("Cannot read properties of undefined (reading 'call')").
// Here they are plain React.lazy boundaries: fetched after hydration, never
// part of the initial bundle.
export const RegionPromptDeferred = dynamic(
  () => import('@/components/region/region-prompt').then((m) => m.RegionPrompt),
  { ssr: false, loading: () => null },
);

export const MarketSwitchToastDeferred = dynamic(
  () =>
    import('@/components/region/market-switch-toast').then(
      (m) => m.MarketSwitchToast,
    ),
  { ssr: false, loading: () => null },
);

export const CookieConsentDeferred = dynamic(
  () => import('@/components/cookie-consent/cookie-consent').then((m) => m.CookieConsent),
  { ssr: false, loading: () => null },
);

export const CreditLimitWarningBannerDeferred = dynamic(
  () =>
    import('@/components/credit-limit-warning/credit-limit-warning-banner').then(
      (m) => m.CreditLimitWarningBanner,
    ),
  { ssr: false, loading: () => null },
);
